import {
	CONTRACT_TEMPLATES_ERROR,
	CONTRACT_TEMPLATES_GET,
	CONTRACT_TEMPLATES_GET_ALL,
	CONTRACT_TEMPLATES_SAVE,
	CONTRACT_TEMPLATES_ADD_UPDATE,
	CONTRACT_TEMPLATE_CLEAR,
	CONTRACT_TEMPLATE_CLEAR_ALL_UPDATES,
	CONTRACT_TEMPLATES_REMOVE_ALL_EDITS,
	CONTRACT_TEMPLATES_GET_RELATED_MARKINGTEAMS
} from '../Enums/Contract.Templates.Enums';

const initState = {
	data: [],
	dataCopy: [],
	total: 0,
	activeStatus: true,
	query: {
		sortOrder: 'asc',
		sortField: 'name',
		page: 1,
		sizePerPage: 10,
		searchText: '',
		exportData: false
	},
	all_data: [],
	errors: [],
	message: '',
	updated: [],
	hasUpdates: false,
	isLoaded: false
};

const templates = (state = initState, action) => {
	let updatedState = {};
	const { type, payload } = action;

	switch (type) {
		case CONTRACT_TEMPLATES_ERROR:
			updatedState = {
				...state,
				errors: payload.errors,
				message: payload.message,
				isLoaded: true
			};
			break;
		case CONTRACT_TEMPLATES_GET:
			updatedState = {
				...state,
				data: payload.data,
				dataCopy: payload.dataCopy,
				total: payload.total,
				errors: payload.errors,
				isLoaded: true,
				message: payload.message
			};
			break;
		case CONTRACT_TEMPLATES_GET_ALL:
			updatedState = {
				...state,
				isLoaded: true,
				all_data: payload.data,
				errors: payload.errors
			};
			break;
		case CONTRACT_TEMPLATES_ADD_UPDATE:
			updatedState = {
				...state,
				updated: action.payload.updates,
				hasUpdates: action.payload.updates.length > 0,
				errors: action.payload.errors
			};
			break;
		case CONTRACT_TEMPLATES_SAVE: {
			let { message, data, dataCopy, total, errors } = payload;
			updatedState = {
				...state,
				hasUpdates: false,
				errors,
				message,
				data,
				dataCopy,
				total,
				updated: []
			};
			break;
		}
		case CONTRACT_TEMPLATE_CLEAR: {
			const { errors } = action.payload;
			updatedState = {
				...state,
				errors,
				message: ''
			};
			break;
		}
		case CONTRACT_TEMPLATE_CLEAR_ALL_UPDATES: {
			updatedState = {
				...state,
				updated: [],
				hasUpdates: false,
				isLoaded: false,
				data: [],
				dataCopy: [],
				total: 0,
				errors: [],
				message: ''
			};
			break;
		}
		case CONTRACT_TEMPLATES_REMOVE_ALL_EDITS: {
			updatedState = {
				...state,
				data: payload.data,
				updated: [],
				hasUpdates: false
			};
			break;			
		}
		case CONTRACT_TEMPLATES_GET_RELATED_MARKINGTEAMS: {
			const { templateRelatedMarkingTeams = [], selectedTemplateId } = payload;
			const { data : mainTableData, dataCopy } = state;
			const setArchiveFlags = item => {
				if (item.id === selectedTemplateId) {
					item.isValidForArchive = false;
					item.invalidArchiveMessage = templateRelatedMarkingTeams;
				}
			};
			if (templateRelatedMarkingTeams.length > 0) {
				mainTableData.forEach(setArchiveFlags);
				dataCopy.forEach(setArchiveFlags);
			}
			updatedState = {
				...state,
				data: mainTableData,
				dataCopy,
				errors: payload.errors,
				message: payload.message
			};
			break;
		}
		default:
			return state;
	}
	return updatedState;
};

export default templates;
